import React, {useState} from "react";
import ConfirmationDialog from "@/lib/components/ConfirmationDialog";
import {CommonI18N, OrderI18N} from "@/translations";
import {useTranslation} from "react-i18next";
import StringInputField from "@/lib/components/inputfields/string-input-field";
import {Constants} from "@/api/constants";

interface OrderRejectDeliveryDateDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (reason: string) => void;
}

const OrderRejectDeliveryDateDialog: React.FC<OrderRejectDeliveryDateDialogProps> = ({ open, onClose, onConfirm }) => {
    const { t } = useTranslation();
    const [reason, setReason] = useState("");

    const handleConfirm = () => {
        onConfirm(reason);
        setReason("");
    };

    const handleClose = () => {
        setReason("");
        onClose();
    };

    return (
        <ConfirmationDialog
            open={open}
            onClose={handleClose}
            onConfirm={handleConfirm}
            title={t(OrderI18N.rejectDeliveryDate.dialog.title)}
            message={t(OrderI18N.rejectDeliveryDate.dialog.message)}
            confirmButtonText={t(CommonI18N.action.save)}
            cancelButtonText={t(CommonI18N.action.cancel)}
            autoFocusConfirm={false}
            closeOnConfirm
        >
            <StringInputField
                    label={t(OrderI18N.rejectDeliveryDate.field.reason)}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                multiline
                maxChars={Constants.DELIVERY_DATE_REJECTION_REASON_LENGTH_MAX}
                sx={{ mt: 2, width: "100%" }}
            />
        </ConfirmationDialog>
    );
};

export default OrderRejectDeliveryDateDialog;
